<template>
  <div style="width:100%">
    <el-row style="padding: 5px;">  
      <el-col :span="10" >
        <el-button v-if="!onlyView" type="success" @click="addTableData()">{{$t('button.uploadFile')}}</el-button>        
      </el-col>  
    </el-row>
    
    <el-row>
      <el-col :span="24">
        <el-table ref="fileUploadTable" :data="tableData.data"  border  highlight-current-row  :empty-text="$t('msg.noDataFound')" v-loading.fullscreen.lock="fullscreenLoading">
          <el-table-column v-for="(v, i) in tableData.columns" :prop="v.field" :label="v.title" :width="v.width" :key="i">
            <template slot-scope="scope">   
              <span v-if="v.field == 'fileName' && scope.row.id != null && scope.row.id!= ''">
                <el-link type="primary" @click="download(scope.row, scope.$index)">{{ scope.row[v.field] }} </el-link>
              </span>   
              <span v-else>{{ scope.row[v.field] }}  </span> 
            </template>
          </el-table-column>
          <el-table-column v-if="!onlyView" :label="$t('action')" width="160">   
            <template slot-scope="scope">    
              <el-button type="warning" @click="updTableData(scope.row, scope.$index)">{{$t('button.edit')}}</el-button>             
              <el-button type="danger" @click="delTableData(scope.row, scope.$index)">{{$t('button.delete')}}</el-button>         
            </template>
          </el-table-column>
        </el-table>      
      </el-col>
    </el-row>

    <el-dialog ref="fileEditDialog" :title="dialogTitle" :visible.sync="dialogVisible" width="70%" :before-close="handleClose" :lock-scroll=true
      :close-on-click-modal=false :close-on-press-escape =false :show-close=false>
      <el-form :model="editFileForm"  label-width="80px">
        <el-row :gutter="10" v-if=" this.editFileForm.action == 'A'" >
          <el-col :span="4" style="text-align: right;">
            <el-button size="mini" :loading="loading"  type="primary" @click="handleUpload" >{{$t('button.choseFile')}}</el-button>
            <input style="display:none" ref="uploadFileObj"  type="file" @change="handleClick"  >
          </el-col>
          <el-col :span="20" style="padding-top: 5px;">
            <span>{{editFileForm.fileName}}  </span>
          </el-col>
        </el-row>
        <br>
        <el-row>
          <el-col :span="22">
            <el-form-item :label="$t('field.fileRemark')" >
              <el-input type="textarea" v-model="editFileForm.remark" rows="5" show-word-limit></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        </el-form>  
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">{{$t('button.cancel')}}</el-button>
          <el-button type="warning" @click="confirmFile">{{$t('button.confirm')}}</el-button>
        </span>         
    </el-dialog>

  </div>
</template>
<script>
/**
 * 傳入的參數
 * 
 * 
 */
import { apiGetAttach, apiSaveAttach } from "../../utils/api.js";
import authHeader from "../../services/auth-header";
import CommonUtil from "../../utils/commonUtil.js";
import AWSUtil from "../../utils/AWSUtil";



const AWS = require('aws-sdk')

AWS.config.update({
  region: AWSUtil.getBucketRegion(),
  credentials: new AWS.CognitoIdentityCredentials({
    IdentityPoolId: AWSUtil.getIdentityPoolId()
  })
});
var s3 = new AWS.S3({
  apiVersion: "2006-03-01",
  params: { Bucket: AWSUtil.getAlbumBucketName() },
  httpOptions: {
		timeout: 30*1000*60,
	},
});

export default {
  props: {
    docId: {
      type: String
    },
    uploadType: {
      type: String
    },
    subFolder: {
      type: String
    },
    onlyView:{
      type: Boolean,
      required: false
    },
    directSave:{
      type: Boolean,
      required: false
    }
  },
  data() {    
    return {
      dialogVisible: false,
      dialogTitle:'',
      tableData: {        
        sel: null, 
        columns: [
          { field: "fileName", title: this.$i18n.t('field.fileName')},         
          { field: "remark", title: this.$i18n.t('field.fileRemark'), width: 300},
          { field: "uploadBy", title: this.$i18n.t('field.uploadBy'), width: 180},
          { field: "uploadDate", title: this.$i18n.t('field.uploadDate'), width: 140}
        ],
        data: []
      },           
      loading:false,    
      fullscreenLoading:false,  
      editFileForm:{
        fileName:'',
        remark:'',        
        action:'',
        id:'',
        currentIndex:-1,
        file:null
      },
      originTableData :[],
      isLastFile:false
    };
  },   
  components: {
    
  },
  mounted() {    
    if(this.docId != null && this.docId != '' && this.docId != 'null'){
      apiGetAttach({ headers: authHeader(), docId : this.docId, uploadType: this.uploadType, subFolder: this.subFolder }).then((response) => {   
        if(response.data != null && response.data.length > 0 ){
          response.data.forEach((item, index) => {
            item.uploadDate = item.uploadDateStr;
          }); 
          this.tableData.data = response.data;
          this.originTableData = JSON.parse(JSON.stringify(this.tableData.data));// 深拷貝作法
        }
            
      }).catch((err) => {
        console.log(err);
      }); 
    }      
  },
  watch:{    
    dialogVisible() {
      if(this.editFileForm.action == 'A'){
        this.dialogTitle = this.$i18n.t('field.createFileTitle');
      } else {
        this.dialogTitle = this.$i18n.t('field.editFileTitle');
      }
    },
    docId(){
      if(this.docId != null && this.docId != '' && this.docId != 'null'){
        apiGetAttach({ headers: authHeader(), docId : this.docId, uploadType: this.uploadType, subFolder: this.subFolder }).then((response) => {   
          if(response.data != null && response.data.length > 0 ){
            response.data.forEach((item, index) => {
              item.uploadDate = item.uploadDateStr;
            }); 
            this.tableData.data = response.data;
            this.originTableData = JSON.parse(JSON.stringify(this.tableData.data));// 深拷貝作法
          }
              
        }).catch((err) => {
          console.log(err);
        }); 
      }      
    }
  },
  methods: {
    readTableData() {
      
    }, 
    addTableData() {  
      this.editFileForm.remark = '';
      this.editFileForm.fileName = '';      
      this.editFileForm.action = 'A';
      this.dialogVisible = true;
    },   
    updTableData(row, index) {      
      row.action = 'U';
      this.dialogVisible = true;     
      this.editFileForm = Object.assign({}, row); 
      this.editFileForm.currentIndex = index;     
    },
    delTableData(row, index){  
      this.$confirm(this.$i18n.t('msg.confirmDelete') +' : '+ row.fileName+'?', {
        confirmButtonText: this.$i18n.t('button.confirm'),
        cancelButtonText: this.$i18n.t('button.cancel'),
        type: 'warning'
      }).then(_ => {
        this.tableData.data.splice(index, 1);
        if(this.directSave){          
          this.save();
        }
        
        
        done();
      }).catch(_ => {});
    },
    handleUpload() {
      this.$refs['uploadFileObj'].click()
    },
    handleClick(e) {      
      const rawFile = e.target.files[0]
      if (!rawFile){  
        this.editFileForm.fileName = '';
        this.editFileForm.file = null;
        return
      }
      this.editFileForm.fileName = rawFile.name;
      this.editFileForm.file = rawFile;
    },
    handleClose(done) {
      this.$confirm(this.$i18n.t('msg.confirmtoClose'),{
        confirmButtonText: this.$i18n.t('button.confirm'),
        cancelButtonText: this.$i18n.t('button.cancel'),
        type: 'warning'
      }).then(_ => {          
        this.dialogVisible = false;          
        done();
      }).catch(_ => {});
    },
    confirmFile(){  

      var file = this.$refs.uploadFileObj;      
      if(this.editFileForm.action == 'A' && (file ==null || file.files.length==0)){
        return this.$message.warning({message: this.$i18n.t('msg.incompleteInfo'), duration: 800});
      } else {  
        var newData = {};
        if(this.editFileForm.action == 'A'){
          newData  = {
            action: this.editFileForm.action == 'A'? 'A': 'U',
            fileName: this.editFileForm.action == 'A'? file.files[0].name : this.editFileForm.fileName,
            remark: this.editFileForm.remark,
            uploadBy: this.$store.state.auth.user.username,
            uploadDate: CommonUtil.dateFormat(new Date()),
            file: this.editFileForm.action == 'A'? file.files : null,
            id: this.editFileForm.action == 'A'? '' : this.editFileForm.id,
            docId: this.editFileForm.action == 'A'? this.docId : this.editFileForm.docId,
            subFolder:this.subFolder
          };   
          this.tableData.data.splice(0, 0, newData);
          this.tableData.sel = JSON.parse(JSON.stringify(newData)); 
          this.$refs.uploadFileObj.files.value =null; 

        } else {
        
          newData = this.tableData.data[this.editFileForm.currentIndex];
          newData.remark = this.editFileForm.remark;
          this.$set( this.tableData.data,  this.editFileForm.currentIndex, newData);
        } 

        if(this.directSave){          
          this.save();
        }else{
          this.dialogVisible = false;
        }
      }
    },
    save(){       
      console.log(typeof this.originTableData)
      //刪除不存在原始資料的資料      
      this.originTableData.forEach((oriData) => {      
        let needDel = true;
        this.tableData.data.forEach((newData) => {
          if(newData.id == oriData.id){
            needDel = false;
            return false;
          }
        }); 
        
        if(needDel){
          var delFileName = 'cust/' + oriData.uploadType + '/' + oriData.docId+'/'+ (CommonUtil.isNull(oriData.subFolder) ? '' : oriData.subFolder+'/') + oriData.fileName;
          this.delS3File(delFileName);
        }
      })
      //upload 本次新增的檔案 isLastFile
      var noFileProcess = true;
      this.tableData.data.forEach((data) => {
        if(data.file != null){
          noFileProcess = false;
          this.addS3File(data);
        }       
      })

      if(noFileProcess || this.tableData.data.length == 0){
        this.$emit('sync-save-status', true); 
      }
      this.saveData();     
    },
    saveData(){
      apiSaveAttach({ headers: authHeader(), docId : this.docId, attachs : this.tableData.data, uploadType: this.uploadType, subFolder: this.subFolder}).then((response) => {        
        this.tableData.data = response.data;
        this.dialogVisible = false;
    
      }).catch((err) => {
        console.log(err);
      }); 
    },
    addS3File(newData){
      
      var albumPhotosKey = 'cust/' + this.uploadType + '/' + this.docId +'/'+ (CommonUtil.isNull(this.subFolder) ? '' : this.subFolder+'/');      
      var photoKey = albumPhotosKey + newData.fileName;
      
      var upload = new AWS.S3.ManagedUpload({
        params: {
          Bucket: AWSUtil.getAlbumBucketName(),
          Key: photoKey,
          Body: newData.file[0]
        },
        httpOptions: {
          timeout: 30*1000*60,
        },
      });
      var promise = upload.promise();      
      promise.then(
        data => { 
          this.$message({ type: "success", message: this.$i18n.t('msg.saveFileSuccess'), duration: 800});    
          this.$emit('sync-save-status', true);             
        },
        err =>{   
          let a = err;
          console.log(err);
          this.$message({ type: "error", message: this.$i18n.t('msg.saveFileFail'), duration: 800});  
          this.$emit('sync-save-status', false);   
        }
      ); 
    },
    delS3File(photoKey){      
      var promise = s3.deleteObject({ Key: photoKey }).promise();
      
      promise.then(
        data => {     
                   
        },
        err =>{          
          this.$message({ type: "error", message: this.$i18n.t('msg.deleteFileFail'), duration: 800});   
        }
      ); 
    },
    download(row, index){
      var a = AWSUtil.getAlbumBucketName()
      this.fullscreenLoading = true;
      // this.createAwsMask();
      var folder = 'cust/' + row.uploadType + '/' + row.docId+'/'+ (CommonUtil.isNull(row.subFolder) ? '' : row.subFolder+'/') + row.fileName;
      const getFile = s3.getObject({Bucket: AWSUtil.getAlbumBucketName(), Key: folder}).promise();
  

      getFile.then((data) => {          
        // function(data) {
          // var el = document.getElementById('awsMask');
          // var textEl = document.getElementById('awsDownloadText');
          // textEl.remove(); 
          // el.remove(); 
          this.fullscreenLoading = false;
          const url = window.URL.createObjectURL(new Blob([data.Body]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', row.fileName)
          document.body.appendChild(link)
          link.click()
          
        // },
        }).catch((err) => {   
          this.fullscreenLoading = false;
          return alert("There was an error downloading your file: ", err.message);
        });
        // function(err) {
          // var el = document.getElementById('awsMask');
          // var textEl = document.getElementById('awsDownloadText');
          // textEl.remove(); 
          // el.remove(); 
         
          
        // });
    },    
    createAwsMask(){
      var elem = document.createElement('div');
      elem.style.cssText = 'position:absolute;top:10px;width:100%;height:100%;opacity:0.2;z-index:9999;background:#000';
      elem.id = 'awsMask'      
      var textElem = document.createElement('span');
      var textNode = document.createTextNode('檔案下載中, 請稍等....');
      textElem.style.cssText = 'position:absolute;top:50px;left:500px;font-size: 20px;font-size: 20px;color: darkred;font-weight: bold;';
      textElem.id = 'awsDownloadText';
      textElem.appendChild(textNode);
      elem.append(textElem);
      document.body.appendChild(elem);
      document.body.appendChild(textElem);
    },
    removeAwsMask(){
      var el = document.getElementById('awsMask');
      var el = document.getElementById('awsDownloadText');
	    el.remove(); 
    }
  }
};
</script>
